import { useLingui } from "@lingui/react";

import { formatPercent } from "@/features/matches";
import { cn } from "@/shared/lib";

import { BUILD_KIND_COLOR, BUILD_KIND_LABEL } from "../../model/BUILD_KIND_LABEL";
import type { CatalogBuildGroup } from "../../model/HeroBuilds";

type KindBarProps = {
  groups: readonly CatalogBuildGroup[];
  total: number;
};

// Типы сборок сильных игроков на герое: полоса долей матчей и подписи от частого к редкому.
export const KindBar = ({ groups, total }: KindBarProps) => {
  const { _, i18n } = useLingui();
  const parts = groups.map((group) => ({
    kind: group.kind,
    label: _({ ...BUILD_KIND_LABEL, values: { kind: group.kind } }),
    share: formatPercent(total === 0 ? 0 : group.matches / total, i18n.locale),
    weight: group.matches,
  }));
  return (
    <div className="flex flex-col gap-2">
      <div
        role="img"
        aria-label={parts.map((part) => `${part.label} ${part.share}`).join(", ")}
        className="flex h-3.5 gap-[3px] overflow-hidden rounded-full"
      >
        {parts.map((part) => (
          <span
            key={part.kind}
            className={cn("block h-full", BUILD_KIND_COLOR[part.kind])}
            style={{ flex: `${part.weight} 1 0` }}
          />
        ))}
      </div>
      <div
        aria-hidden="true"
        className="flex flex-wrap gap-x-4.5 gap-y-1.5 text-[13px] text-foreground-soft"
      >
        {parts.map((part) => (
          <span key={part.kind} className="inline-flex items-center gap-1.5">
            <span className={cn("size-2.5 rounded-full", BUILD_KIND_COLOR[part.kind])} />
            {part.label} <span className="font-mono text-foreground">{part.share}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
